import Script from "next/script";
import { checkIfSiteimpact } from "../../utils/partner";
import { IS_DEV } from "../../data/js/server-constants";

const isSiteimpact = checkIfSiteimpact()

const AdSense = () => {
	if (IS_DEV) return null;

	// Disable ads during Cypress tests
	if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).Cypress) {
		return null;
	}

	return (
		<>
			<Script
				// strategy="lazyOnload"
				src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
				{...(isSiteimpact ? { } : { strategy: "lazyOnload" })}
			/>
			{/* Disabled GPT/Prebid script - causing runtime errors */}
			{/* <Script
				id="ad-sense-tag"
				{...(isSiteimpact ? { } : { strategy: "afterInteractive" })}
				dangerouslySetInnerHTML={{
					__html: `
					!(function () {
						try {
							window.googletag = window.googletag || {};
							window.vmpbjs = window.vmpbjs || {};
							window.vpb = window.vpb || {};
							vpb.fastLoad = true;
							googletag.cmd = googletag.cmd || [];
							vmpbjs.cmd = vmpbjs.cmd || [];
							var cmds = [];
							try{ cmds = googletag.cmd.slice(0); googletag.cmd.length = 0; }catch(e){}
							var ready = false;
							function exec(cb) { return cb.call(googletag); }
							var overriden = false;
							googletag.cmd.push(function () {
								overriden = true;
								googletag.cmd.unshift = function (cb) {
									if (ready) { return exec(cb); }
									if (cmds) cmds.unshift(cb);
									if (cb._startgpt) {
										ready = true;
										for (var k = 0; k < cmds.length; k++) { exec(cmds[k]); }
									}
								};
								googletag.cmd.push = function (cb) {
									if (ready) { return exec(cb); }
									if (cmds) cmds.push(cb);
								};
							});
							if(!overriden){
								googletag.cmd.push = function (cb) { if (cmds) cmds.push(cb); };
								googletag.cmd.unshift = function (cb) {
									if (cmds) cmds.unshift(cb);
									if (cb._startgpt) {
										ready = true;
										if (googletag.apiReady) {
											cmds.forEach(function (cb) { googletag.cmd.push(cb); });
										} else {
											googletag.cmd = cmds;
										}
									}
								};
							}
							var dayMs = 36e5,
								cb = parseInt(Date.now() / dayMs),
								vpbSrc = '//player.ads.sellwild.com/prebidlink/' + cb + '/wrapper_hb_324410_11875.js',
								pbSrc = vpbSrc.replace('wrapper_hb', 'hb'),
								gptSrc = '//securepubads.g.doubleclick.net/tag/js/gpt.js',
								c = document.head || document.body || document.documentElement;
							function loadScript(src, cb) {
								var s = document.createElement('script');
								s.src = src;
								s.defer=false;
								c.appendChild(s);
								s.onload = cb;
								s.onerror = function(){
									var fn = function(){};
									fn._startgpt = true;
									googletag.cmd.unshift(fn);
								};
								return s;
							}
							loadScript(pbSrc);
							loadScript(gptSrc);
							loadScript(vpbSrc);
						} catch (e) {
							console.error("GPT initialization error:", e);
						}
					})()
					`,
				}}
			/> */}
			{/*
			  There was a page-level `adsbygoogle.push({ google_ad_client })` here. With
			  `enable_page_level_ads` commented out it is not a config push at all —
			  AdSense reads it as one more request to fill an ad unit. Every `<ins>` we
			  render already carries its own `data-ad-client`/`data-ad-slot` and gets
			  its own push from components/ad.tsx, so by the time this ran
			  (`afterInteractive`) there was never an unfilled `ins` left for it, and it
			  threw `TagError: All 'ins' elements in the DOM with class=adsbygoogle
			  already have ads in them` — asynchronously, from Google's script, where
			  our try/catch could not reach it. It requested nothing that the per-unit
			  pushes were not already requesting, so it is gone rather than guarded.

			  Restoring Auto ads means pushing `{ google_ad_client, enable_page_level_ads: true }`
			  BEFORE any per-unit push, not adding this one back.
			*/}
		</>
	);
};

export default AdSense;
